/* eslint-disable react/no-danger */

import * as React from 'react';

import type {LeadCardData} from 'nutshell-core/types';

import {Avatar} from '../avatar/avatar';
import {Card} from '../card/card';

import styles from './lead-card-basic.module.css';

type Props = {
    openLinkInNewTab?: boolean;
    showRelatedEntities?: boolean;
} & LeadCardData;

export class LeadCardBasic extends React.PureComponent<Props> {
    render() {
        const {avatarUrl, leadName, assignee, relatedCompany, relatedPerson, value} = this.props;

        return (
            <Card hasBorder={true}>
                <div className={styles.container}>
                    <header className={styles.header}>
                        <div
                            className={
                                this.props.showRelatedEntities
                                    ? styles['header-border-container']
                                    : styles['header-container']
                            }
                        >
                            <div className={styles.avatar}>
                                <Avatar type='leads' avatarUrl={avatarUrl} size={36} />
                            </div>
                            <div className={styles['header-info']}>
                                <a
                                    href={this.props.htmlUrl}
                                    target={this.props.openLinkInNewTab ? '_blank' : '_self'}
                                    rel={this.props.openLinkInNewTab ? 'noopener noreferrer' : ''}
                                    className={styles['top-row']}
                                >
                                    <span dangerouslySetInnerHTML={{__html: leadName}} />
                                </a>
                                <div className={styles['bottom-row']}>
                                    <span>{value}</span>
                                    <span className={styles.spacer}>•</span>
                                    <span className={styles.assignee}>
                                        {assignee ? assignee.name : 'Unassigned'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </header>
                    {this.props.showRelatedEntities ? (
                        <div className={styles.body}>
                            <div className={styles['related-entity-container']}>
                                <div className={styles['related-entity']}>
                                    {relatedCompany ? (
                                        <a
                                            href={relatedCompany.htmlUrl}
                                            target={
                                                this.props.openLinkInNewTab ? '_blank' : '_self'
                                            }
                                            rel={
                                                this.props.openLinkInNewTab
                                                    ? 'noopener noreferrer'
                                                    : ''
                                            }
                                            className={styles['related-company']}
                                        >
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: relatedCompany.name,
                                                }}
                                            />
                                        </a>
                                    ) : (
                                        <i>No company added</i>
                                    )}
                                </div>
                                <div className={styles['related-entity']}>
                                    {relatedPerson ? (
                                        <a
                                            href={relatedPerson.htmlUrl}
                                            target={
                                                this.props.openLinkInNewTab ? '_blank' : '_self'
                                            }
                                            rel={
                                                this.props.openLinkInNewTab
                                                    ? 'noopener noreferrer'
                                                    : ''
                                            }
                                            className={styles['related-person']}
                                        >
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: relatedPerson.name,
                                                }}
                                            />
                                        </a>
                                    ) : (
                                        <i>No person added</i>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </Card>
        );
    }
}
